/**
* @file 运营中心-旅游包车订单
* */
<template>
  <div id="order">
    <finance-summary-card
      summary-url="/api/v1/manage/financeFlowing/hitchRide/summary"
      :params="summaryParams"
      type="hitchRide"
      @hook:created="syncSummaryParams"
    />

    <custom-table excel-type="FinanceFlowingHitchRide" :summaryList="[
        { name: 'orderFee', beforeUnit: '￥' },
        { name: 'realFee', beforeUnit: '￥' },
        { name: 'driverIncome', beforeUnit: '￥' },
        { name: 'serviceFee', beforeUnit: '￥' },
        { name: 'companyIncome', beforeUnit: '￥' },
      ]" ref="customTable" :customOptions="customOptions" :columns="columns"
                  labelWidth="135"
                  @search="onSearch">
      <template slot-scope="{ item, row }">
        <template v-if="item.prop == 'operation'">
          <el-button type="text" @click="showOrderDetail(row)">详情</el-button>
        </template>
        <template v-else-if="item.prop == 'created'">{{ row.created | filterTime }}</template>


        <template v-else-if="item.prop === 'startStationName'">
          <div>{{ row.startStationName }}</div>
        </template>
        <template v-else-if="item.prop === 'endStationName'">
          <div>{{ row.endStationName }}</div>

        </template>
        <template v-else-if="item.prop == 'licenseNo'">
          <span 
            v-if="row.licenseNo"
            :style="getPlateStyle(row.licenseNo)"
            @dblclick="$utils.dblclickCopy"
          >{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
          <span v-if="row.vehicleSeat" style="margin-left: 4px;">{{ row.vehicleSeat }}座</span>
        </template>

        <template v-else-if="item.prop == 'channelAlias'">
          {{ row.channelAlias | filterConst('HITCHHIKINGCHANNEL') }}
        </template>
        <template v-else-if="item.prop == 'incomeType'">
          {{ row.incomeType | filterConst('INCOME') }}
        </template>


        <template v-else-if="item.prop == 'orderFee'">
          <span class="util-money">
            ¥{{ row.orderFee || 0 }}
          </span>
        </template>
        <template v-else-if="item.prop == 'driverIncome'">
          <span>
            <span class="util-money">¥{{ row.driverIncome || 0 }}</span>
            <span v-if="row.cancelRatio">
             ({{ row.cancelRatio }})
            </span>
          </span>
        </template>
        <template v-else-if="item.prop == 'serviceFee'">
          <span class="util-money">
            ¥{{ row.serviceFee || 0 }}
          </span>
        </template>
        <template v-else-if="item.prop == 'companyIncome'">
          <span>
             <span class="util-money">¥{{ row.companyIncome || 0 }}</span>
            <span v-if="row.companyIncomeRatio">
             ({{ row.companyIncomeRatio }})
            </span>
          </span>
        </template>

        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
      </template>
    </custom-table>


    <!-- 财务流水详情抽屉 -->
    <el-drawer
        :visible.sync="orderDetailVisible"
        title="财务流水详情"
        size="550px"
        :append-to-body="true">
      <div class="finance-detail" v-if="currentOrderDetail">
        <!-- 订单信息 -->
        <div class="detail-section">
          <div class="section-title">订单信息</div>
          <el-descriptions :column="1" border size="medium">
            <el-descriptions-item label="订单号">
              <span @dblclick="$utils.dblclickCopy">{{ currentOrderDetail.orderNo || '-' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="订单来源">
              {{ currentOrderDetail.channelAlias | filterConst('HITCHHIKINGCHANNEL') }}
            </el-descriptions-item>
            <el-descriptions-item label="收入类型">
              <el-tag :type="currentOrderDetail.incomeType == '完单' ? 'success' : (currentOrderDetail.incomeType == '退款' ? 'danger' : 'warning')" size="small">
                {{ currentOrderDetail.incomeType || '-' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="归属渠道">{{ currentOrderDetail.channelName || '-' }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 线路信息 -->
        <div class="detail-section">
          <div class="section-title">线路信息</div>
          <el-descriptions :column="1" border size="medium">
            <el-descriptions-item label="出发地">{{ currentOrderDetail.startStationName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="目的地">{{ currentOrderDetail.endStationName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="乘车人数">{{ currentOrderDetail.passengerNum || 0 }}人</el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 司机车辆信息 -->
        <div class="detail-section">
          <div class="section-title">司机车辆信息</div>
          <el-descriptions :column="1" border size="medium">
            <el-descriptions-item label="司机姓名">{{ currentOrderDetail.driverName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="车辆号牌">
              <span @dblclick="$utils.dblclickCopy">{{ currentOrderDetail.licenseNo || '-' }}</span>
              <span v-if="currentOrderDetail.vehicleSeat"> {{ currentOrderDetail.vehicleSeat }}座</span>
            </el-descriptions-item>
            <el-descriptions-item label="车辆编号">{{ currentOrderDetail.vehicleNo || '-' }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 费用信息 -->
        <div class="detail-section">
          <div class="section-title">费用信息</div>
          <el-descriptions :column="1" border size="medium">
            <el-descriptions-item label="订单金额">
              <span class="util-money">￥{{ currentOrderDetail.orderFee || 0 }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="司机收入">
              <span class="util-money">￥{{ currentOrderDetail.driverIncome || 0 }}</span>
              <span v-if="currentOrderDetail.cancelRatio" style="color: #909399;"> ({{ currentOrderDetail.cancelRatio }})</span>
            </el-descriptions-item>
            <el-descriptions-item label="信息费">
              <span class="util-money">￥{{ currentOrderDetail.serviceFee || 0 }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="平台收入">
              <span class="util-money">￥{{ currentOrderDetail.companyIncome || 0 }}</span>
              <span v-if="currentOrderDetail.companyIncomeRatio" style="color: #909399;"> ({{ currentOrderDetail.companyIncomeRatio }})</span>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 时间信息 -->
        <div class="detail-section">
          <div class="section-title">时间信息</div>
          <el-descriptions :column="1" border size="medium">
            <el-descriptions-item label="完单/取消时间">{{ currentOrderDetail.created | filterTime }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "order",
  components: {
    FinanceSummaryCard: () => import('./components/financeSummaryCard.vue')
  },
  data() {
    return {
      // 订单详情抽屉
      orderDetailVisible: false,
      currentOrderDetail: {},
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/financeFlowing/hitchRide",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {type: "input", field: "orderNo", name: "订单号", value: ""},
          {
            type: "select",
            field: "channelAlias",
            name: "订单类型",
            value: "",
            option: this.$const.HITCHHIKINGCHANNEL,
          },
          {
            type: "select", field: "incomeType", name: "收入类型", value: "",
            option: [
              {value: '完单', label: '完单'},
              {value: '销单', label: '销单'},
              {value: '退款', label: '退款'},
            ]
          },
          {type: "input", field: "licenseNo", name: "车辆信息", value: ""},
          {type: "input", field: "vehicleNo", name: "车辆编号", value: ""},
          {type: "input", field: "driverName", name: "司机姓名", value: ""},
          {type: "input", field: "customerPhone", name: "乘客手机号", value: ""},
          {
            type: "datetime",
            field: "time",
            dateProp: {start: "startTime", end: "endTime"},
            name: "记录时间",
            value: []
          },
        ],
      },
      summaryParams: {},
      // 表头
      columns: [
        {prop: "orderNo", label: "订单号", minWidth: 180},
        {prop: "channelAlias", label: "订单来源", minWidth: 100},
        {prop: "incomeType", label: "收入类型", minWidth: 100},
        {prop: "licenseNo", label: "车辆号牌", minWidth: 130},
        {prop: "vehicleNo", label: "车辆编号", minWidth: 100},
        {prop: "driverName", label: "司机姓名", minWidth: 100},
        {prop: "customerName", label: "乘客姓名", minWidth: 100},
        {prop: "channelName", label: "归属渠道", minWidth: 130},
        {prop: "startStationName", label: "出发地", minWidth: 180},
        {prop: "endStationName", label: "目的地", minWidth: 180},
        {prop: "passengerNum", label: "乘车人数", minWidth: 80},
        {prop: "orderFee", label: "订单金额", minWidth: 100},
        {prop: "realFee", label: "实际支付", minWidth: 100},
        {prop: "driverIncome", label: "司机收入", minWidth: 130},
        {prop: "serviceFee", label: "信息费", minWidth: 80},
        {prop: "companyIncome", label: "平台收入", minWidth: 130},
        {prop: "created", label: "完单/取消时间", minWidth: 150},
        {prop: "operation", label: "操作", width: 80, align: "center"},
      ],
      // 状态
      status: null,
      show: false,
      showCancel: false,
      rowData: {}
    };
  },
  watch: {},
  methods: {
    actionFn({type, row}) {
      switch (type) {
        case "look":
          this.rowData = row;
          this.show = true;
          break;
      }
    },
    /**
     * 状态改变
     */

    handClose() {
      this.rowData = {}
      this.show = false
      this.showCancel = false
    },
    /**
     * 显示订单详情
     */
    showOrderDetail(row) {
      this.currentOrderDetail = { ...row };
      this.orderDetailVisible = true;
    },
    syncSummaryParams() {
      if (this.$refs.customTable) {
        this.summaryParams = { ...this.$refs.customTable.getParams() }
      }
    },
    onSearch(params) {
      this.summaryParams = { ...params }
    }
  },
  created() {
  },
};
</script>

<style scoped lang="less">
#order {
  .finance-detail {
    padding: 20px;
    
    .detail-section {
      margin-bottom: 20px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .section-title {
        font-size: 15px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 12px;
        padding-left: 10px;
        border-left: 3px solid #409EFF;
      }
    }
  }
}
</style>
